import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import CreateJob from '@/components/CreateJob'
import SignIn from '@/components/User/SignIn'
import ResetPassword from '@/components/User/ResetPassword'
import Settings from '@/components/Settings'
import CurrentJob from '@/components/CurrentJob'
import JobList from '@/components/JobList'
import CustomerList from '@/components/CustomerList'
import Outbox from '@/components/Outbox'
import Testing from '@/components/Testing'
import BulkSMS from '@/components/BulkSMS'
import CurrentJobGuard from './CurrentJobGuard'
import AuthGuard from './AuthGuard'
import NotAuthGuard from './NotAuthGuard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/SignIn',
      name: 'SignIn',
      component: SignIn,
      beforeEnter: NotAuthGuard
    },
    {
      path: '/ResetPassword/:initialEmail',
      name: 'ResetPassword',
      props: true,
      component: ResetPassword
    },
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: AuthGuard
    },
    {
      path: '/createJob',
      name: 'CreateJob',
      component: CreateJob,
      beforeEnter: AuthGuard
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      beforeEnter: AuthGuard
    },
    {
      path: '/currentJob',
      name: CurrentJob,
      component: CurrentJob,
      beforeEnter: CurrentJobGuard
    },
    {
      path: '/jobList',
      name: 'JobList',
      component: JobList,
      beforeEnter: AuthGuard
    },
    {
      path: '/outbox',
      name: 'Outbox',
      component: Outbox,
      beforeEnter: AuthGuard
    },
    {
      path: '/customerList',
      name: 'CustomerList',
      component: CustomerList,
      beforeEnter: AuthGuard
    },
    {
      path: '/Testing',
      name: 'Testing',
      component: Testing
    },
    {
      path: '/BulkSMS',
      name: 'BulkSMS',
      component: BulkSMS,
      beforeEnter: AuthGuard
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js